// extracted by mini-css-extract-plugin
export var grayCircle = "_ef-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_ef-1";
export var selectedCircle = "_ef-2";
export var shippingOptionImage = "_ef-3";
export var shippingOptionWidgetPreview = "_ef-4";